import _ from 'underscore';
import { FolderAssetType } from '@bingads-webui-campaign-react/asset-library-model';

JSON.stringifyWithBigInt = (data) => {
  // add markers to BigInt values in the string
  let str = JSON.stringify(data, (key, value) => (typeof value === 'bigint' ? `BIGINT<<${value}>>TNIGIB` : value));
  // serialize a BigInt as number instead of string
  str = str.replace(/"BIGINT<<[0-9]+>>TNIGIB"/g, s => s.slice(9, -9));
  return str;
};

export const oDataTypeConfig = {
  [FolderAssetType.Image]: '#Model.Image',
  [FolderAssetType.Video]: '#Model.Video',
};

export const namePropertyConfig = {
  [FolderAssetType.Image]: 'Text',
  [FolderAssetType.Video]: 'Description',
};

// UI is using IdString internally
// When passing to MT, need to convert to int type
// Theoretically there should not be overflow issue, but here we still do a guard.
// If overflow happens, pass a string so MT will fail and then will be caught
export const transformAssetId = (value) => {
  if (_.isNumber(value)) {
    return value;
  }

  const pattern = /^[0-9]+$/g;
  const SAFE_INTEGER = Number.MAX_SAFE_INTEGER;
  if (value.match(pattern)) {
    const intValue = parseInt(value, 10);
    if (intValue.toString() === value && intValue <= SAFE_INTEGER) {
      return intValue;
    }

    // use BigInt if the value is bigger than SAFE_INTEGER
    // eslint-disable-next-line no-undef
    const bigIntValue = BigInt(value);
    if (bigIntValue.toString() === value) {
      return bigIntValue;
    }
  }

  return value;
};
